// Copyright (c) Ping. All rights reserved.
//
// Max-width constraint for message tiles. The main chat room renders tiles at
// their Figma widths (268–300px); the thread panels (`ThreadOpenPanel` /
// `CallThreadPanel`) live inside a narrow ~320–360px side panel, so they
// provide a cap here and EVERY tile — self or other, bubble or compact —
// reads it and shrinks to fit (the voice waveform re-samples its bar count to
// the available width). Context so no per-tile prop plumbing is needed through
// `MessageRow` / `StackedMessageRow`; `null` (the default) means "no cap".

import { createContext, useContext } from 'react';

/** The width (px) message tiles cap to inside the thread side panel. */
export const THREAD_TILE_MAX_WIDTH = 250;

/** Provided max tile width in px, or `null` for the unconstrained main chat. */
export const TileMaxWidthContext = createContext<number | null>(null);

export function useTileMaxWidth(): number | null {
  return useContext(TileMaxWidthContext);
}
